import { useTranslation } from "react-i18next";
import React, { useRef } from "react";
import { Button, ButtonsContainer, LeftSide } from "./AdminHeader.styles";

import { useNavigate } from "react-router-dom";
import SearchInput from "../Search/Search";
import { selectBusinessUserInfo } from "../../store/slices/businessUser/slice";
import { checkPermission } from "../../utils/utils";
import { businessUserRoleAction } from "../../utils/constants";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { updateInventoryQuantityItem } from "../../store/slices/marketplace/asyncThunks";
import { ReactComponent as Loading } from "../../assets/icons/loader-white.svg";
import { selectUpdateInventoryQuantityItemPending } from "../../store/slices/marketplace/marketplaceSlice";
import openToast from "../../utils/toast";

const LeftSideComponent = ({ showButtons, hideSearch }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const toastId = useRef(null);

  const businessUser = useSelector(selectBusinessUserInfo);
  const updateInventoryQuantityItemPending = useSelector(
    selectUpdateInventoryQuantityItemPending,
  );

  const handleOnClickAdd = () => {
    const dataToSend = {
      action: "create",
    };
    navigate(`/admin-portal/marketplace/add-an-item/${dataToSend.action}`, {
      state: dataToSend,
    });
  };

  const handleOnClickUpdate = () => {
    dispatch(updateInventoryQuantityItem())
      .unwrap()
      .then(() => {
        openToast(
          toastId,
          "items-update",
          "info",
          t("successfully-updated-availability"),
        );
      })
      .catch((err) =>
        openToast(toastId, "items-update", "error", t(err.message)),
      );
  };
  return (
    <LeftSide>
      {!hideSearch && <SearchInput />}

      {/* {showButtons && ( */}
      <ButtonsContainer>
        {checkPermission(businessUser, businessUserRoleAction.post_item) && (
          <Button
            onClick={() => {
              handleOnClickAdd();
            }}
          >
            {t("add-item")}
          </Button>
        )}
        {checkPermission(
          businessUser,
          businessUserRoleAction.post_category,
        ) && (
          <Button
            onClick={() => {
              navigate("/admin-portal/marketplace/categories");
            }}
          >
            {t("categories.categories")}
          </Button>
        )}
        {checkPermission(
          businessUser,
          businessUserRoleAction.post_subcategory,
        ) && (
          <Button
            onClick={() => {
              navigate("/admin-portal/marketplace/attributes");
            }}
          >
            {t("attributes")}
          </Button>
        )}
        {checkPermission(
          businessUser,
          businessUserRoleAction.post_items_availability,
        ) && (
          <Button
            onClick={() => {
              handleOnClickUpdate();
            }}
          >
            {!updateInventoryQuantityItemPending ? (
              <>{t("update-items-availability")}</>
            ) : (
              <Loading height={20} />
            )}
          </Button>
        )}
      </ButtonsContainer>
      {/* )} */}
    </LeftSide>
  );
};

export default LeftSideComponent;
